import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/brand/ui_ux design.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const UIUXDesign = () => {
  const heroData = {
    title: "User-Centered UI/UX Design Services",
    description: "Create exceptional digital experiences that delight users and drive business results. We design intuitive interfaces that combine beauty with functionality for web, mobile, and software applications.",
    image: img13,
    imageAlt: "UI/UX Design",
    features: [
      "User research & testing",
      "Wireframes & prototypes",
      "Visual interface design",
      "Interaction design",
      "Design systems",
      "Usability optimization",
    ],
    pillars: [
      "User-centered design that prioritizes needs and behaviors",
      "Beautiful interfaces that enhance brand and drive engagement",
      "Data-driven optimization that improves conversion and retention",
    ],
  };

  const journeySteps = [
    {
      title: "Research & Discovery",
      description: "We understand your users, their pain points, and goals through research, analysis, and competitive benchmarking.",
      details: ["User research", "Persona development", "Journey mapping", "Competitive analysis", "Heuristic evaluation", "Analytics review"],
    },
    {
      title: "Information Architecture",
      description: "We structure content and flows logically, creating wireframes that map out functionality and user paths.",
      details: ["Sitemap creation", "User flows", "Wireframing", "Content strategy", "Navigation design", "Feature mapping"],
    },
    {
      title: "Visual Design & Prototyping",
      description: "Our designers create beautiful, on-brand interfaces and interactive prototypes that bring the experience to life.",
      details: ["Visual design", "Style exploration", "Component design", "Interactive prototypes", "Micro-interactions", "Animation design"],
    },
    {
      title: "Testing & Handoff",
      description: "User testing validates the design, and comprehensive documentation ensures smooth developer implementation.",
      details: ["Usability testing", "A/B testing", "Design refinement", "Developer handoff", "Design system", "Documentation"],
    },
  ];

  const capabilities = [
    {
      title: "Web Design",
      content:
        "Responsive website design that delivers seamless experiences across all devices and screen sizes with modern aesthetics.",
    },
    {
      title: "Mobile App Design",
      content:
        "Native iOS and Android app interfaces that follow platform guidelines while maintaining brand consistency.",
    },
    {
      title: "SaaS & Dashboard Design",
      content:
        "Complex data visualization and dashboard interfaces that make information accessible and actionable for users.",
    },
    {
      title: "Design Systems",
      content:
        "Scalable design systems with component libraries, guidelines, and patterns for consistent product evolution.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "45%", label: "Average conversion increase" },
      { value: "60%", label: "Reduction in user errors" },
      { value: "4.8/5", label: "Average user satisfaction" },
    ],
    description: "We deliver UI/UX designs that significantly improve user satisfaction, conversion rates, and overall product success through thoughtful, research-backed design.",
  };

  const outcomesData = {
    description: "We create user-centered designs that combine research insights with visual excellence to deliver intuitive, engaging digital experiences.",
    outcomes: [
      "Complete user research and persona documentation",
      "Detailed wireframes and user flow diagrams",
      "High-fidelity visual designs for all screens",
      "Interactive clickable prototypes",
      "Comprehensive design system and components",
      "Developer-ready specifications and assets",
    ],
  };

  const whyChooseUs = [
    {
      title: "User-First Approach",
      content:
        "We ground every design decision in user research and testing to ensure experiences that truly resonate with your audience.",
    },
    {
      title: "Cross-Platform Expertise",
      content:
        "Our team designs for web, iOS, Android, and desktop with deep knowledge of platform conventions and best practices.",
    },
    {
      title: "Scalable Design Systems",
      content:
        "We build design systems that enable your team to maintain consistency and move faster as your product grows.",
    },
    {
      title: "Conversion Focused",
      content:
        "Beautiful design that drives results—we optimize for metrics that matter to your business goals.",
    },
  ];

  const faqs = [
    {
      q: "What's the difference between UI and UX design?",
      a: "UX (User Experience) design focuses on the overall feel and flow of a product—how users interact and accomplish their goals. UI (User Interface) design focuses on visual elements—colors, typography, buttons, and layout. We provide both, ensuring your product is both beautiful and intuitive to use."
    },
    {
      q: "Do you design for both web and mobile apps?",
      a: "Yes! We design responsive websites, native mobile apps (iOS and Android), web applications, and SaaS platforms. Our team has expertise in platform-specific guidelines and best practices while maintaining consistent brand experience across all devices."
    },
    {
      q: "How do you measure the success of a UI/UX design?",
      a: "We track key metrics including user satisfaction scores, task completion rates, time-on-task, error rates, conversion rates, and engagement metrics. We conduct usability testing before launch and A/B testing after to continuously optimize the design for better performance."
    },
    {
      q: "Can you work with our existing design or development team?",
      a: "Absolutely! We collaborate seamlessly with in-house teams, providing design deliverables, documentation, and developer handoff materials. We can integrate with your existing design systems, style guides, and development workflows to ensure smooth implementation."
    }
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"UI/UX Design"}
            pagesub={"Branding & Design"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our UI/UX Design Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default UIUXDesign;
